import { createContext } from "@lit/context";
import type { Chat } from "../models/chat";
export const chatContext = createContext<Chat>('chat')